module.exports = __webpack_public_path__ + "static/media/logo_dark.6a38b82f.png";